// extracted by mini-css-extract-plugin
module.exports = {"registerForm":"RegisterForm_registerForm__1q-16","registerButton":"RegisterForm_registerButton__1Ry7u","error":"RegisterForm_error__1LgF9"};